import { render, staticRenderFns } from "./DealBuyersAgreementAction.vue?vue&type=template&id=ef8197ec&scoped=true"
import script from "./DealBuyersAgreementAction.vue?vue&type=script&lang=js"
export * from "./DealBuyersAgreementAction.vue?vue&type=script&lang=js"
import "./DealBuyersAgreementAction.vue?vue&type=style&index=0&id=ef8197ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8197ec",
  null
  
)

export default component.exports